import type { OpenAPI } from "simplydo/interfaces";

import type {
  MessagesAction,
  SelectedMessageThread,
} from "../reducers/messages";

type MessageThread = OpenAPI.Schemas["MessageThread"];

const messagesActions = {
  MESSAGE_THREADS_RECEIVED: "MESSAGE_THREADS_RECEIVED",
  MESSAGE_THREAD_SELECTED: "MESSAGE_THREAD_SELECTED",
  MESSAGE_THREADS_EXTEND: "MESSAGE_THREADS_EXTEND",
  MARK_MESSAGE_THREADS_AS_SEEN: "MARK_MESSAGE_THREADS_AS_SEEN",
  CLOSE_MESSAGE_THREAD: "CLOSE_MESSAGE_THREAD",
  LOGOUT: "LOGOUT",
  ON_THREAD_CREATED: "ON_THREAD_CREATED",

  receiveThreads(
    threads: MessageThread[],
    newMessageCount: number,
  ): MessagesAction {
    return { type: "MESSAGE_THREADS_RECEIVED", threads, newMessageCount };
  },
  selectThread(
    thread: SelectedMessageThread | null,
    isPhone = false,
  ): MessagesAction {
    return { type: "MESSAGE_THREAD_SELECTED", thread, isPhone };
  },
  extendThreads(threads: MessageThread[]): MessagesAction {
    return { type: "MESSAGE_THREADS_EXTEND", threads };
  },
  markMessageThreadsAsSeen(
    messageThreads: string[],
    markAllAsSeen: boolean,
    userId: string,
    newMessageCount: number,
  ): MessagesAction {
    return {
      type: "MARK_MESSAGE_THREADS_AS_SEEN",
      messageThreads,
      markAllAsSeen,
      userId,
      newMessageCount,
    };
  },
  closeMessageThread(threadId: string): MessagesAction {
    return { type: "CLOSE_MESSAGE_THREAD", threadId };
  },
  onThreadCreated(newThreadId: string, thread: MessageThread): MessagesAction {
    return { type: "ON_THREAD_CREATED", newThreadId, thread };
  },
  logout(): MessagesAction {
    return { type: "LOGOUT" };
  },
};

export default messagesActions;
